import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatUpdateMutationAtom = createMutationAtomFactory(
  'assistant.chatUpdate',
  (params: { id: string; title: string }) => ({
    assistantUpdateChat: {
      __args: {
        id: params.id,
        input: { title: params.title },
      },
      id: true,
      title: true,
    },
  }),
);
